<template>

  <div class="content-wrap">

    <!-- 2024-11-19 지워달라는 요청 
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span style="color: red;">총 잉여잔액은 매주 수요일(0시) 업데이트 됩니다.</span>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <div class="search-detail-wrap"></div>-->
    
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div v-if="!state.uploadPossible">기준일자: {{ state.reg_dt }}(W{{state.data_weekly_cnt}})</div>
      <div v-else>등록시 : {{state.basedateWeekly}}</div>
      <!-- <ElButton type="search">검색</ElButton> -->
      <div class="table-btn-group d-flex align-items-center">
        <ElButton type="excelDownload" @buttonClick="excelDown()">
          엑셀다운
        </ElButton>
        <img src="/images/vr.png" alt="" />
        <span class="rd-won">(단위:원)</span>
      </div>
    </div>

<div class="table-container">
    <div ref="tableHeader" class="table-responsive" style="height: 40rem;">
      <table class="table table-rt table-hover">
        <thead>
          <tr class="tr-rt2 fh-top">
            <!-- <th ref="firstTableHeader">
              구분
            </th> -->
            <th ref="firstTableHeader" v-for="header in [...state.templateHeader].filter((key)=>key.field!='group_cd')"
              :key="header.field">{{ header.headerName }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in state.rows" :key="index"
            :class="[row.class === 'table-item total text-start' ? 'bb-1' : '']">
            <td :class="[row.class ? row.class : 'table-item']">{{ row.classified }}</td>
            <td 
              v-for="(monthNm,index2) in month"
              :class="returnClassNm(row.class)"
              :key="index2"
            >
              <span v-if="row[monthNm] % 1 === 0" :class="isNegative(row[monthNm])">{{ checkFloat(parseInt(row[monthNm])) || 0 }}</span>
              <span v-else :class="isNegative(row[monthNm])">{{ checkFloat( Math.round(row[monthNm])) || 0}}</span>
            </td>
            <td v-if="total && index == 0"  class="center-text" > 
              <span :class="isNegative(row['total'])">{{ row['total'] }}</span>
            </td>
            <td v-else-if="row.classified == '총 잉여 잔액'"  class="sum center-text" > 
              <span :class="isNegative(row['total'])">{{ row['total'] }}</span>
            </td>
            <td v-else-if="row.classified == '총 잉여 잔액 : A'"  class="total center-text" > 
              <span :class="isNegative(row['total'])">{{ row['total'] }}</span>
            </td>
            <td v-else  :class="returnClassNm(row.class)"> 
              <span v-if="row['total'] % 1 === 0" :class="isNegative(row['total'])">{{ checkFloat(parseInt(row['total'])) || row['total'] }}</span>
              <span v-else :class="isNegative(row['total'])">{{ checkFloat( Math.round(row['total'])) || row['total'] }}</span>
            </td>
          </tr>

          <tr class="tr-space">
            <td colspan="13" style="border-right: 0 !important;border-top:solid 1px #a5b3c2;"></td>
          </tr>

          <tr class="bt-2">
            <td class="table-item sum text-start bg-light bb-0">총 잉여 잔액(지난주) : B</td>
            <td 
              v-for="(monthNm,index3) in month"
              class="sum bb-0"
              :key="index3"
            >
              <span  :class="isNegative(summaryB[monthNm])">{{ checkFloat( Math.round(summaryB[monthNm])) || 0 }}</span>
            </td>
            <td v-if="total"   class="sum bb-0 center-text" > 
              <span :class="isNegative(summaryB['total'])">{{ 'N/A' }}</span>
            </td>
          </tr>
          <tr>
            <td class="table-item sum text-start">변동금액 (A-B)</td>
            <td 
              v-for="(monthNm,index4) in month"
              class="sum"
              :key="index4"
            >
              <span :class="isNegative(lastWeekDif[monthNm])">{{ checkFloat(Math.round(lastWeekDif[monthNm])) || 0 }}</span>
            </td>
            <td v-if="total"   class="sum center-text" > 
              <span :class="isNegative(summaryB['total'])">{{ 'N/A' }}</span>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div ref="tableBody" class="table-responsive mt-3" style="height:13rem">
      <table class="table table-rt table-hover">
        <thead>
          <tr class="tr-rt2 fh-top">
            <!-- <th  ref="secondTableHeader" :style="{ width: '600' + 'px' }">
              일자
            </th> -->
            
            <th ref="secondTableHeader" v-for="header in [...state.templateHeader2].filter((key)=>key.field!='group_cd')"
              :key="header.field">{{ header.headerName }}</th>
          </tr>
          
        </thead>
        <tbody>
          
          <tr class="bt-2" v-for="(item, index) in state.weeklySummary" :key="index">
            <!-- <td class="table-item sum text-start bg-light bb-0" style="min-width: 160px;">{{ `W${item.weeklyCnt}_${item.ycfr_year}${item.week}` }}</td> -->
            <td class="table-item sum text-start bg-light bb-0" :style="{ minWidth: firstTableHeaderWidth + 'px'}">{{ `W${item.weeklyCnt}_${item.ycfr_year}${item.week}` }}</td>
            <td 
              v-for="(monthNm,index5) in month"
              class="sum bb-0"
              :key="index5"
              style="min-width: 112px;"
            >
              <span :class="isNegative(item[monthNm])">{{ checkFloat(Math.round(item[monthNm])) || 0 }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="excelTemplateDown()">템플릿 다운</ElButton>
      <ElButton type="primary" @buttonClick="selectExcelFile()">엑셀 업로드</ElButton>
      <ElButton type="primary" @buttonClick="save()">등록</ElButton>
      <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
    </div>

  </div>



  <ExcelManage ref="excelManageRef" v-show="false" :header-keys="state.templateHeader.map((item) => item.field)"
    @return="getExcelData" />

</template>

<script setup>
import { reactive, onBeforeMount, ref, computed, onMounted,nextTick ,watch} from "vue";
import ExcelManage from "@/components/common/MCO_EX_002.vue";
import common from "@/js/common";
import { useRouter } from "vue-router";
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { getCashFlowList } from "@/api/monthly";
import { yearlyCacheFlowFsctExcelUpload , yearlyCacheFlowRealRsltWeeklyListReport } from '@/api/ycf'
import { useUserStore } from "@/store/user";
import { groupBy } from "lodash";
const userStore = useUserStore()
const router = useRouter();
const excelManageRef = ref()
let summaryA = ref(new Object())
let summaryB = ref(new Object())
const tableHeader = ref(null);
const tableBody = ref(null);
const firstTableHeader = ref(null);
const secondTableHeader = ref(null);
const firstTableHeaderWidth = ref(0);


const lastWeekDif = computed(() => {
  let obj = new Object()
  state.templateHeader.map((item) => item.field).forEach((key) => {
    if (key === 'classified' || key ==='group_cd') return    
    if (!summaryA.value[key]) summaryA.value[key] = 0
    if (!summaryB.value[key]) summaryB.value[key] = 0

    obj[key] = summaryA.value[key] - summaryB.value[key]

  })

  return obj
})


onBeforeMount(async () => {
  await fetchCashFlowList();  // 데이터 리스트
  await WeeklyListReport()
  //settingDefaultList()

});

onMounted(() => {
  syncColumnWidth();
  observeTableHeader();
  tableBody.value.addEventListener('scroll', () => {
    tableHeader.value.scrollLeft = tableBody.value.scrollLeft;
  });
  tableHeader.value.addEventListener('scroll', () => {
    tableBody.value.scrollLeft = tableHeader.value.scrollLeft;
  });

  // const isDarkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  // applyDarkModeStyles(isDarkModeMediaQuery.matches);

  // 다크 모드 설정 변경 감지
  // isDarkModeMediaQuery.addEventListener('change', (event) => {
  //   applyDarkModeStyles(event.matches);
  // });
});

const applyDarkModeStyles = (isDarkMode) => {
  const root = document.documentElement;
  if (isDarkMode) {
    root.style.setProperty('--bs-body-color', '#f8f9fa');
    root.style.setProperty('--bs-table-color', '#f8f9fa');
  } else {
    root.style.setProperty('--bs-body-color', '#212529');
    root.style.setProperty('--bs-table-color', '#212529');
  }
};

const month = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec']
const total = 'total'
//변수
const state = reactive({
  uploadPossible : false,
  searchParams: {
    fs_year: '',       // 회계년도   
  },
  // /allSelectedStatus: 0,
  columns: [
    { name: '구분', prop: 'classified'},
    { name: 'jan', prop: 'jan', autoSize: true }, { name: 'feb', prop: 'feb', autoSize: true }, { name: 'mar', prop: 'mar', autoSize: true },
    { name: 'apr', prop: 'apr', autoSize: true }, { name: 'may', prop: 'may', autoSize: true }, { name: 'jun', prop: 'jun', autoSize: true },
    { name: 'jul', prop: 'jul', autoSize: true }, { name: 'aug', prop: 'aug', autoSize: true }, { name: 'sep', prop: 'sep', autoSize: true },
    { name: 'oct', prop: 'oct', autoSize: true }, { name: 'nov', prop: 'nov', autoSize: true }, { name: 'dec', prop: 'dec', autoSize: true },
  ],
  fixedFirstCol: {},
  // for으로 생성을 할려고 하면 Revo 그리드는 엑셀 데이터를 재배정 처리가 안되어서 초기화로 진행처리 (차후 운영에서 처리)
  rows: [],
  templateHeader: [
    { headerName: "group_cd", field: "group_cd" },
    { headerName: "구분", field: "classified" },
    { headerName: "Jan", field: "jan" },
    { headerName: "Feb", field: "feb" },
    { headerName: "Mar", field: "mar" },
    { headerName: "Apr", field: "apr" },
    { headerName: "May", field: "may" },
    { headerName: "Jun", field: "jun" },
    { headerName: "Jul", field: "jul" },
    { headerName: "Aug", field: "aug" },
    { headerName: "Sep", field: "sep" },
    { headerName: "Oct", field: "oct" },
    { headerName: "Nov", field: "nov" },
    { headerName: "Dec", field: "dec" },
    { headerName: "Total", field: "total" },
  ],
  templateHeader2: [
    { headerName: "일자", field: "classified" },
    { headerName: "Jan", field: "jan" },
    { headerName: "Feb", field: "feb" },
    { headerName: "Mar", field: "mar" },
    { headerName: "Apr", field: "apr" },
    { headerName: "May", field: "may" },
    { headerName: "Jun", field: "jun" },
    { headerName: "Jul", field: "jul" },
    { headerName: "Aug", field: "aug" },
    { headerName: "Sep", field: "sep" },
    { headerName: "Oct", field: "oct" },
    { headerName: "Nov", field: "nov" },
    { headerName: "Dec", field: "dec" }
  ],
  templateHeaderDownload:[
  { headerName: "group_cd", field: "group_cd" },
    { headerName: "구분", field: "classified" },
    { headerName: "Jan", field: "jan" },
    { headerName: "Feb", field: "feb" },
    { headerName: "Mar", field: "mar" },
    { headerName: "Apr", field: "apr" },
    { headerName: "May", field: "may" },
    { headerName: "Jun", field: "jun" },
    { headerName: "Jul", field: "jul" },
    { headerName: "Aug", field: "aug" },
    { headerName: "Sep", field: "sep" },
    { headerName: "Oct", field: "oct" },
    { headerName: "Nov", field: "nov" },
    { headerName: "Dec", field: "dec" },
  ],
  templateDataList: [],
  summaryList: [],
  weeklySummary: [],
  excelFile : null,
  reg_dt : '',
  data_weekly_cnt : '',
  basedateWeekly : '',
});



//뒤로가기
const goBack = () => {
  router.go(-1);
};


const syncColumnWidth = () => {
  requestAnimationFrame(() => {
    nextTick(() => {
      if (firstTableHeader.value[0] && secondTableHeader.value) {
        const width = firstTableHeader.value[0].getBoundingClientRect().width;
        if (width > 0) {
          firstTableHeaderWidth.value = width;
        }
      }
    });
  });
};

const observeTableHeader = () => {
  if (!firstTableHeader.value) return;

  const observer = new ResizeObserver(() => {
    syncColumnWidth();
  });

  observer.observe(firstTableHeader.value[0]);
};

// 조회건  
const fetchCashFlowList = async (r) => {
  let params = {
    fs_year: new Date().getFullYear(),
    employee_id : userStore.user.employeeId
  }

  //임원,관리자는 전체 검색
  if(['ADMIN', 'E'].includes(userStore.user.authGrpId)) params.employee_id = ''

  try {
    setIsLoading(true)
    const res = await getCashFlowList(params)
    state.reg_dt = res.rtn[0].reg_dt
    state.fixedFirstCol = []
    state.fixedFirstCol = res.rtn.map((item,index) => {
      const newItem = {};
      let total = 0; 
      Object.keys(item).forEach((key) => {
        let newKey = key.replaceAll('real', '');
        newItem[newKey] = newKey !== 'classified' ? item[key] : item[key.replaceAll('real', '')];
        if (key !== "reg_dt" && key !== "weekly_cnt" && key !== "group_cd") {
          if(item['classified'] && index !== 0){
            total += isNaN(Number(item[key])) ? 0 : Number(item[key]);
          }else{
            total = 'N/A'
          }
    }

        newItem.total = total
      });
      
      return newItem;
    });

    await contentList(state.fixedFirstCol)
    
  } catch (err) {
    console.log('error', err)
    alert('조회 에러');
  } finally {
    setIsLoading(false)
  }
};



const selectExcelFile = () => {
  excelManageRef.value.selectUploadFile()
}

const contentList = async (data) =>{
  let summary = new Object()
  let dataIsNan = false
  let overallSummary = {}; 
  let totalA = {}; // 그룹 A의 합계를 저장할 객체
  let totalBtoE = {}; // 그룹 B~E의 합계를 저장할 객체

  data.forEach((item, index)=>{
    if(data[0].weekly_cnt){
      state.data_weekly_cnt = data[0].weekly_cnt
    }
    if(Object.keys(item).length > 14) dataIsNan = true
      if(item.group_cd){

      
      //카테고리별 row의 월별 데이터 집계
      Object.keys(item).filter((i) => {if(i !== 'classified' && i !== 'group_cd'){return i}}).forEach((key) => {
        if(isNaN(Number(item[key]))) {
          dataIsNan = true
        }
        //해당 카테고리 소계
        if (!summary[key]) summary[key] = 0
        summary[key] = isNaN(Number(item[key])) ? summary[key] : (Number(item[key]) + Number(summary[key]))

        //모든 카테고리의 총 비용 금액 계산
        if (item.group_cd === 'B' || item.group_cd === 'C' || item.group_cd === 'D' || item.group_cd === 'E') {
          if (!overallSummary[key]) overallSummary[key] = 0;
          overallSummary[key] = isNaN(Number(item[key])) ? overallSummary[key] : (Number(item[key]) + Number(overallSummary[key]));
        }
        // 그룹 A 합계 계산
        if (item.group_cd === 'A') {
          if (!totalA[key]) totalA[key] = 0;
          totalA[key] = isNaN(Number(item[key])) ? totalA[key] : (Number(item[key]) + Number(totalA[key]));
        }

        // 그룹 B~E 합계 계산
        if (item.group_cd === 'B' || item.group_cd === 'C' || item.group_cd === 'D' || item.group_cd === 'E') {
          if (!totalBtoE[key]) totalBtoE[key] = 0;
          totalBtoE[key] = isNaN(Number(item[key])) ? totalBtoE[key] : (Number(item[key]) + Number(totalBtoE[key]));
        }
       
        if(!Number.isInteger(Number(item.key))){
          item.key = isNaN(Number(item[key])) ? item[key] : Number(item[key]).toFixed(1)
        }
        
      })
      state.rows.push(item)
      const isGroupEnd = index === data.length - 1 || data[index + 1].group_cd !== item.group_cd;
      if (isGroupEnd) {
        switch (item.group_cd) {
          case 'A':
            summary['classified'] = '총 잉여 잔액'
            summary['type'] = 'totalSurplus'
            summary['total'] = 'N/A'
            break

          case 'B':
            summary['classified'] = '총 고정비'
            summary['type'] = 'totalfixed'
            break

          case 'C':
            summary['classified'] = '총 변동비'
            summary['type'] = 'totalVariable'
            break

          case 'D':
            summary['classified'] = '총 사옥비용'
            summary['type'] = 'totalOfficeBldg'
            break
          case 'E':
            summary['classified'] = '총 비용 금액'
            summary['type'] = 'totalexpense'
            Object.keys(overallSummary).forEach((key) => {
              summary[key] = overallSummary[key];
            });
            break
        }
        // summary['classified'] = item.classified + ' 합계';
        summary['class'] = 'table-item sum text-start';
        state.summaryList.push(summary);
        state.rows.push(summary);
        summary = new Object();
      }
    }
  })

    //A : 총 잉여 잔액-(고정비+변동비+사옥비+비용)
    summaryA.value = {}
    summaryA.value['class'] = 'table-item total text-start'
    summaryA.value['classified'] = '총 잉여 잔액 : A'
    Object.keys(overallSummary).forEach((key) => {
      if (key !== 'classified' && key !== 'group_cd') {
        summaryA.value[key] = (totalA[key] || 0) - (totalBtoE[key] || 0);
      }
      if(key == 'total'){
        summaryA.value[key] ='N/A'
      }
    });
    state.rows.push(summaryA.value)
}


//업로드한 엑셀 데이터 
const getExcelData = async (excelData) => {
  state.summaryList = []
  if (excelData.sheets?.length > 0) {
    state.rows = []
    const data = excelData.sheets[0].splice(0,0, { ...state.fixedFirstCol })
    await contentList(excelData.sheets[0])
    state.excelFile = excelData.file
    state.uploadPossible = true
    basedate()
    firstTableHeaderWidth.value = firstTableHeader.value?.offsetWidth
  }

}

const basedate = () =>{
  const today = new Date();
  const dayOfWeek = today.getDay();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0')
  if (dayOfWeek === 1 || dayOfWeek === 2 || dayOfWeek === 0) {
    state.basedateWeekly = `${year}년 ${month}월 ${day}일 (W${getYearWeek(today)})`
  } else {
    state.basedateWeekly = `${year}년 ${month}월 ${day}일 (W${getYearWeek(today)+1})`
  }
}

//템플릿 다운로드
const excelTemplateDown = () => {
  settingDefaultList()
  const fileName = `Yearly Cashflow FCST 템플릿`
  const header = [...state.templateHeaderDownload]
  const dataList = [...state.templateDataList]
  excelManageRef.value.excelSheet3(fileName, header, dataList)
}

//table > td class
const returnClassNm = (parentClass) => {
  let tdClassNm = ''
  switch (parentClass) {
    case 'table-item total text-start':
      tdClassNm = 'total'
      break;
    case 'table-item sum text-start':
      tdClassNm = 'sum'
      break;
  }
  return tdClassNm
}

//주차별 수요일 날짜 구하기
async function WeeklyListReport(){

  let today = new Date();
  let dayOfWeek = today.getDay(); // 현재 요일 (0: 일요일, 6: 토요일)
  let dif = 3 - dayOfWeek; // 수요일 기준으로 맞추기

  let date = new Date(today.setDate(today.getDate() + dif)); // 이번 주 수요일로 설정

  let lastWeekCnt = getYearWeek(new Date(new Date(new Date().setDate(new Date().getDate() + dif)).setDate(date.getDate() - 7)))

  try{
    setIsLoading(true)

    state.weeklySummary = []
    let weeklyList = []

    let params ={
      fs_year : new Date().getFullYear()
    }

    const res = await yearlyCacheFlowRealRsltWeeklyListReport(params)
    const responseList = [...res.rtn]
    for (let i = 1; i <= 52; i++) {
      //전 주차 계산 
      let weekCnt = getYearWeek(date); // 현재 주차
      responseList.forEach((item)=>{
        if(item.weekly_cnt === weekCnt.toString() && date.getFullYear() == item.ycfr_year ){
          item.week = common.dateFormat(date, '').substring(4)

          weeklyList.push(item)
        }
      })
      date = new Date(date.setDate(date.getDate() - 7))
    }


    //table 헤더 키값에 맞게 재설정 col1~12 -> jan~dec
    weeklyList.forEach((weekData, index2)=>{
      let weeklySummary = {}

      state.templateHeader.map((item) => item.field).forEach((key,index) => {
        // 0 인덱스는 몇주차인지 정보 그 외는 월별 수치 데이터
        if(index===0){
          weeklySummary.week = `${weekData.week}` 
          weeklySummary.ycfr_year = `${weekData.ycfr_year}` 
          weeklySummary.weeklyCnt = `${weekData.weekly_cnt}`           
        } else if(index === 1) {
          weeklySummary.classified = `W${weeklySummary.weeklyCnt}_${weeklySummary.ycfr_year}${weeklySummary.week}`
        }else{
          weeklySummary[key] = isNaN(weekData[`col${index-1}`]) ? 0 : Math.floor(Number(weekData[`col${index-1}`])*10) / 10
        }
      })     
      if(weeklySummary && index2 == 0){
        summaryB.value = weeklySummary

        summaryB.value.map

      }
      state.weeklySummary.push(weeklySummary)
    })
    state.weeklySummary = [...state.weeklySummary]
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
  
}

async function save() {
    if(!state.excelFile || !state.uploadPossible){
      alert('등록 가능한 엑셀 파일이 없습니다.')
      return
    }


    if (confirm('등록하시겠습니까?')) {
      try{
        setIsLoading(true)
        const formData = new FormData()
        formData.append('excel_file',state.excelFile)

        let res = await yearlyCacheFlowFsctExcelUpload(formData)

        if(res.code !== '0000') throw new Error() 
        
        alert('등록완료했습니다.')
        state.rows = []
        await fetchCashFlowList();  // 데이터 리스트
        await WeeklyListReport()
        state.uploadPossible = !state.uploadPossible;
      }catch(err){
        if(!err.toString().includes('0005')){
          alert('등록에 실패했습니다.')
        }
        console.log(err)
      } finally {
        setIsLoading(false)
      }
      
    }

}

function getYearWeek(date=new Date()){
    const onejan = new Date(date.getFullYear(),0,1);
    
    return Math.ceil((((date - onejan) / 86400000) + onejan.getDay()+1)/7);
};

function excelDown(){
  let parts = state.reg_dt.split('일')
  const fileNm = `Yearly Cashflow FCST_${parts[0].trim()??''}(W${state.data_weekly_cnt})`
  const header = [...state.templateHeader]
  let dataList = [...state.rows]
  const header2 = [...state.templateHeader2]
  const dataList2 = [...state.weeklySummary]
  dataList.map(item =>{
    item['subject'] = `기준일자:${ state.reg_dt }(W${state.data_weekly_cnt})`
  }) 
  excelManageRef.value.excelSheet2(fileNm,header,dataList,header2,dataList2)
}

function checkFloat(data){
  if(!isNaN(Number(data)) && !Number.isInteger(Number(data))){
    data = Number(data).toFixed(1)
  }
  return common.checkNumberComma(data)
}

function settingDefaultList(check){
  let form = []
  state.rows.map(r =>{
    if(r.classified && r.group_cd){
      form.push({ classified: r.classified , group_cd:r.group_cd})
    }
  }) 
  state.templateDataList = form;
  let obj = { sheets: [[...state.templateDataList]] }
  if(check){
    return
  }else{

    //getExcelData(obj)
  }
}

function isNegative(data){
  if(data =='N/A'){
    return 'center-text'
  }
  
  if(!data) return
  data = data.toString().replaceAll('%','')

  if(Number(data) < 0){
    return 'text-b-rt'
  }
}
</script>

<style scoped>
@media screen and (max-width: 992px) {
  .table-responsive{
    overflow: auto;
    scroll-snap-type: x mandatory; /* y 축 방향으로만 scroll snap 적용 */
  }
  .table-rt .table-item {
    width: 160px;
  }
  .table-rt tr {
    width: 100%;
  }
  .table-rt th:not(.table-item),
  .table-rt td:not(.table-item) {
    scroll-snap-align: start; /* 스크롤 위치 맞춤 */
    width: 41.9rem
  }
}

@media screen and (max-width: 767px) {
  .table-rt th:not(.table-item),
  .table-rt td:not(.table-item) {
    width: 30.6rem
  }
}
.center-text {
    text-align: center;
}
</style>